import { render, staticRenderFns } from "./annualleave.vue?vue&type=template&id=089013ff"
import script from "./annualleave.vue?vue&type=script&lang=js"
export * from "./annualleave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports